import { Tool } from '../../types';

export const designTools: Tool[] = [
  {
    id: 'figma',
    name: 'Figma',
    category: 'Design & Creative',
    description: 'Browser-based collaborative interface design tool used by teams worldwide. Create UI/UX designs, prototypes, and design systems together in real-time. Features version control, commenting, and extensive plugin ecosystem for modern product design.',
    pricing: ['free', 'medium'],
    features: ['collaboration', 'integrations', 'ease-of-use'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['agency', 'saas'],
    goals: ['streamline-operations', 'build-brand'],
    industries: ['technology', 'creative', 'marketing'],
    website: 'https://www.figma.com',
    imageUrl: 'https://logo.clearbit.com/figma.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'adobe-creative-cloud',
    name: 'Adobe Creative Cloud',
    category: 'Design & Creative',
    description: 'Industry-standard suite of 20+ creative applications including Photoshop, Illustrator, Premiere Pro, and After Effects. Professional-grade tools for photo editing, graphic design, video production, and digital marketing content creation.',
    pricing: ['high'],
    features: ['integrations', 'mobile', 'scalability'],
    bestFor: ['small-business', 'agency'],
    compatibleWith: ['agency', 'content-creator'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['creative', 'marketing', 'technology'],
    website: 'https://www.adobe.com/creativecloud.html',
    imageUrl: 'https://logo.clearbit.com/adobe.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'canva',
    name: 'Canva',
    category: 'Design & Creative',
    description: 'User-friendly graphic design platform that makes professional design accessible to everyone. Create social media posts, presentations, logos, and marketing materials using drag-and-drop tools and thousands of customizable templates.',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['marketing', 'creative', 'retail'],
    website: 'https://www.canva.com',
    imageUrl: 'https://logo.clearbit.com/canva.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  }
];